module.exports = __webpack_public_path__ + "img/logo-white.b4055315.png";